import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/ImageOverlay.css';

const ImageOverlay = ({ isOpen, imageName, onClose }) => {
  const [isPopping, setIsPopping] = useState(false);

  const handlePop = () => {
    setIsPopping(true);
    setTimeout(() => {
      setIsPopping(false);
      onClose();
    }, 500);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="overlay-wrapper">
          {/* Backdrop */}
          <motion.div
            className="overlay-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: isPopping ? 0 : 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={handlePop}
          />

          {/* Image */}
          <motion.div
            className="overlay-image-bubble"
            initial={{ scale: 0, borderRadius: '50%' }}
            animate={isPopping
              ? { scale: [1, 1.3, 0], borderRadius: '50%', opacity: [1, 1, 0] }
              : { scale: 1, borderRadius: '12px' }
            }
            exit={{ scale: 0, opacity: 0 }}
            transition={isPopping
              ? { duration: 0.5, ease: 'easeOut' }
              : { type: 'spring', stiffness: 200, damping: 20 }
            }
            onClick={handlePop}
          >
            <img src={`/images/${imageName}`} alt="Wedding moment" />
          </motion.div>

          {/* Pop particles */}
          <AnimatePresence>
            {isPopping && (
              <div className="pop-particles-container">
                {Array.from({ length: 10 }, (_, i) => {
                  const angle = (i * 36) * Math.PI / 180;
                  const distance = 150 + Math.random() * 150;
                  return (
                    <motion.div
                      key={i}
                      className="pop-particle"
                      initial={{ x: 0, y: 0, scale: 1, opacity: 1 }}
                      animate={{
                        x: Math.cos(angle) * distance,
                        y: Math.sin(angle) * distance,
                        scale: 0,
                        opacity: 0
                      }}
                      transition={{ duration: 0.5, ease: 'easeOut' }}
                    />
                  );
                })}
              </div>
            )}
          </AnimatePresence>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ImageOverlay;
